import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {GeospatialViewerApi} from './geospatial-viewer.api';
import {
    FindGeospatialOutagesRequest,
    FindGeospatialOutagesResponse,
    GeoJSONGeometry,
    FindGeospatialEntitiesRequest,
    FindGeospatialEntitiesResponse,
    GeospatialSearchAssetRequest,
} from '../model/api';
import {GeospatialTooltipRequest, GeospatialTooltipResponse} from '../model/tooltip.model';
import {APIResponse} from '@core/interfaces/system/system-common';
import {map} from 'rxjs/operators';
import {SubstationAssetListRequest, SubstationAssetListResponse} from '../model/substation.model';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';

@Injectable()
export class GeospatialViewerService {
    constructor(private api: GeospatialViewerApi) {}

    /*
     * APIs to fetch core map data, i.e., spatial entities
     */
    // Metric layer
    public getMapGeoEntities(
        workflowItemId: number,
        request: FindGeospatialEntitiesRequest,
    ): Observable<FindGeospatialEntitiesResponse> {
        return this.api.getMapGeoEntities(workflowItemId, request);
    }

    // Outage layer
    public getMapOutageGeoEntities(request: FindGeospatialOutagesRequest): Observable<FindGeospatialOutagesResponse> {
        return this.api
            .getMapGeoOutageEntities(request)
            .pipe(map((res: APIResponse<FindGeospatialOutagesResponse>) => res.response));
    }

    /*
     * APIs for tooltips
     */
    /** Some tooltips need a studyId, some do not */
    public getGeospatialTooltipData(
        workflowItemId: number,
        request: GeospatialTooltipRequest,
    ): Observable<GeospatialTooltipResponse> {
        return this.api.getGeospatialTooltipData(workflowItemId, request);
    }

    public getSubstationAssetList(
        workflowItemId: number,
        request: SubstationAssetListRequest,
    ): Observable<SubstationAssetListResponse> {
        return this.api.getSubstationAssetList(workflowItemId, request);
    }

    /*
     * Custom data layers: not implemented yet
     */

    /*
     * Support for searching
     */
    public getSearchAssetList(req: GeospatialSearchAssetRequest): Observable<any> {
        return this.api.getSearchAssetList(req);
    }

    public getSearchAssetInfo(req: string): Observable<GeoJSONGeometry> {
        return this.api.getSearchAssetInfo(req);
    }
}
